<template lang="pug">
  .d-flex
    .pa-1.flex-grow-1
      v-text-field(
        :value="value"
        ref="clipboardField"
        v-bind="$attrs"
        color="secondary"
        readonly
        rounded
        hide-details
        @focus="(e) => e.target.select()"
      )
    .pa-1
      v-tooltip(top)
        template(v-slot:activator="{ on }")
          v-btn(
            v-on="on"
            depressed
            rounded
            fab
            color="secondary"
            @click="copy"
          )
            v-icon(small) mdi-checkbox-multiple-blank
        span Скопировать
</template>

<script>
export default {
  props: {
    value: { type: String, required: true },
  },
  methods: {
    selectInput() {
      this.$refs.clipboardField.$refs.input.select();
    },
    copy() {
      this.selectInput();
      document.execCommand('copy');
      this.$emit('copied');
      this.$toasted.info('Текст скопирован в буфер обмена', { duration: 5000 });
    },
  },
};
</script>
